import {AfterViewInit, Component, computed, CUSTOM_ELEMENTS_SCHEMA, effect, ElementRef, input, viewChild, ChangeDetectionStrategy} from "@angular/core"
import {TestCaseEntry, updateIframe} from "@app/test/manual-testing/helpers/configurator-test-helpers"
import {getBasicPage} from "@app/test/manual-testing/material-download/helpers/pages"
import {TestContainerComponent} from "@app/test/manual-testing/test-container/test-container.component"
import {materialDownloadUrls, Source} from "@app/test/manual-testing/types/types"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-material-download-test",
    templateUrl: "./material-download.component.html",
    styleUrls: ["./material-download.component.scss"],
    imports: [TestContainerComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MaterialDownloadTestComponent implements AfterViewInit {
    readonly $source = input.required<Source>({alias: "source"})

    private readonly $iframe = viewChild.required<ElementRef<HTMLIFrameElement>>("iframe")

    readonly $moduleUrl = computed(() => materialDownloadUrls[this.$source()])

    testCases: TestCaseEntry[] = [
        {
            type: "info",
            name: "Download something",
            tooltip: "Check, if the links are working.",
            fct: () => {},
        },
    ]

    ngAfterViewInit() {
        this.loadDefaultPage()
    }

    constructor() {
        effect(() => {
            this.loadDefaultPage()
        })
    }

    private loadDefaultPage() {
        const _doc = this.$iframe().nativeElement.contentDocument
        updateIframe(this.$iframe().nativeElement, getBasicPage(this.$moduleUrl()))
    }
}
